import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  Box,
  HeadingStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { BackArrow } from "../../../../components/styled/AllImages";
import { useTranslation } from "react-i18next";
import SignupStep1 from "./SignupStep1";
import SignupStep2 from "./SignupStep2";
import SignupStep3 from "./SignupStep3";
import { useForm } from "react-hook-form";
import { useUser } from "../../../../context/userContext";
import AuthApi from "../../../../services/api/authApi";
import LicenseStep2 from "./addLicenseSteps/LicenseStep2";
import LicenseStep1 from "./addLicenseSteps/LicenseStep1";

const payment_method = {
  card: "card",
  bank_transfer: "bank_transfer",
};
const signupSteps = [
  //   {
  //       label: "signup_to_cloudarchive",
  //       component: SignupStep1
  //   },
  {
    //   label: "signup_to_cloudarchive",
    component: LicenseStep1,
    fields: ["payment_method"],
  },
  {
    //   label: "signup_to_cloudarchive",
    component: LicenseStep2,
    fields: {
      [payment_method.card]: [
        // "cardHolderName",
        // "cardNumber",
        // "expiryDate",
        // "cvv",
      ],
      [payment_method.bank_transfer]: ["payment_proof"],
    },
  },
];

const AddLicenseForm = ({ addLicenseFrm, onHide, action, planInfo, title }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();
  const [currentStep, setCurrentStep] = useState(signupSteps[0]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [bankInfo, setBankInfo] = useState({});
  const [paymentMethod, setPaymentMethod] = useState(null);
  const currentStepIndex = signupSteps.indexOf(currentStep);
  const {
    watch,
    register,
    setValue,
    control,
    trigger,
    getFieldState,
    formState: { errors },
  } = useForm();

  const [planDetails, setPlanDetails] = useState({});

  const getPlanInfo = async (id, type) => {
    try {
      const { data, code } = await AuthApi.getPlanInfo(id, type);
      if (code === 200) {
        setPlanDetails({
          ...data,
          amount:
            data?.plan_prices?.find(
              (price) => price?.duration == planInfo?.duration
            )?.price || "",
          duration: planInfo?.duration || 1,
        });
      } else {
        setPlanDetails(planInfo);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (planInfo?.id) {
      getPlanInfo(planInfo?.id, planInfo?.type || "public");
    }
  }, [planInfo]);

  // useEffect(() => {
  //   if (action === "extend" && title !== t("AddLicense"))
  //     setValue(
  //       "number_of_licenses",
  //       Number(user?.current_organization?.number_of_licenses)
  //     );
  // }, [user, action]);

  const getFieldsToValidate = () => {
    const step = signupSteps[currentStepIndex];

    if (currentStepIndex < 1) {
      return step.fields;
    }
    return step.fields[paymentMethod] || [];
  };

  const validateCurrentStep = async () => {
    const fieldsToValidate = getFieldsToValidate();

    if (currentStepIndex === 1 && !paymentMethod) {
      return false;
    }

    const isValid = await trigger(fieldsToValidate);
    return isValid;
  };

  const handleSteps = async (e) => {
    e.preventDefault();
    const isCurrentStepValid = await validateCurrentStep();

    console.log(isCurrentStepValid, currentStepIndex);

    if (!isCurrentStepValid) {
      return;
    }
    if (currentStepIndex < 1) {
      setCurrentStep(signupSteps[currentStepIndex + 1]);
    }
  };
  const getBankInfo = async () => {
    try {
      const { data, code } = await AuthApi.getBankInfo();
      if (code === 200) {
        setBankInfo(data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    getBankInfo();
  }, [language]);

  return (
    <Form>
      {/* <Box className="mb-4">
        <HeadingStyled
          size="24px"
          weight="bold"
          color="var(--text)"
          className="d-flex align-items-center"
        >
          {currentStepIndex > 0 && (
            <>
              <SpanStyled className="mb-1">
                <BackArrow
                  className="back-btn cursor-pointer"
                  onClick={() => setCurrentStep(signupSteps[currentStepIndex - 1])}
                />
              </SpanStyled>
              &nbsp;
            </>
          )}
          {t(currentStep.label)}
        </HeadingStyled>
      </Box> */}
      <currentStep.component
        user={user}
        bankInfo={bankInfo}
        planInfo={planDetails}
        handleSteps={handleSteps}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        addLicenseFrm={addLicenseFrm}
        totalAmount={totalAmount}
        setTotalAmount={setTotalAmount}
        watch={watch}
        register={register}
        errors={errors}
        control={control}
        getFieldState={getFieldState}
        setValue={setValue}
        onHide={onHide}
        action={action}
      />
    </Form>
  );
};

export default AddLicenseForm;
